module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/thread-loader/dist/cjs.js!../../../node_modules/babel-loader/lib/index.js??clonedRuleSet-6.use[1]!../../../node_modules/ts-loader/index.js??clonedRuleSet-6.use[2]!./task-manager.ts"));
	}, "employee-calendar");
}